/**
 * `/auth/signed-out` — the confirmation landing after an explicit sign-out.
 * Offers a route back to centralized login.
 */
import { redirectToCentralizedLogin } from '@/auth/silentRefresh';
import { useCopy } from '@/hooks/useCopy';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export function SignedOut() {
  const { t } = useCopy();
  useDocumentTitle(t('auth.signedOutTitle', 'Signed out'));
  return (
    <main style={{ padding: '2rem', maxWidth: '32rem', margin: '0 auto' }}>
      <h1>{t('auth.signedOutTitle', 'Signed out')}</h1>
      <p>{t('auth.signedOutBody', 'You have been signed out of WSReporting.')}</p>
      <button type="button" onClick={() => redirectToCentralizedLogin('/')}>
        {t('auth.signInAgain', 'Sign in again')}
      </button>
    </main>
  );
}
